import React from "react";
import styled, { css } from "styled-components";

import { Text } from "src/library/components/Text";
import { Datetime } from "src/library/components/Datetime";
import Grid from "src/library/components/Hedron";
import HtmlBody from "src/library/components/Notes/HtmlBody";

interface SupportTicketDetailsProps {
  createdAt: Date;
  message: string;
  title: string;
}

const SupportTicketDetails: React.ReactFCWithChildren<SupportTicketDetailsProps> = ({
  createdAt, message, title
}) => {
  return (
    <TicketDetails direction="vertical">
      <TicketDetailsTitle direction="horizontal">
        <Text
          fontSize="h4"
          weight="bold"
        >
          {title}
        </Text>

        <Text>
          <Datetime
            date={createdAt}
            format="HH:mm ddd D MMM YYYY"
          />
        </Text>
      </TicketDetailsTitle>

      <HtmlBody body={message} />
    </TicketDetails>
  );
};

const TicketDetails = styled(Grid.Bounds)`
  ${({ theme }) => css`
    border: 1px solid ${theme.colors.lightGrey};
    background: ${theme.colors.white};
    border-radius: ${theme.borderRadius};
    margin: ${theme.spacing.padding.sm} 0;
    margin-bottom: ${theme.spacing.padding.lg} 0;
    padding: ${theme.spacing.padding.sm};
    position: relative;

    div {
      p:first-child {
        padding-top: 0;
      }

      p:last-child {
        margin-bottom: 0;
      }
    }

    &:after {
      content: "";
      display: block;
      height: 2px;
      width: 100%;
      background: ${theme.colors.lightGrey};
      position: absolute;
      top: calc(100% + (${theme.spacing.padding.lg} / 2) - 2px);
      left: 0;
    }
  `}
`;

const TicketDetailsTitle = styled(Grid.Bounds)`
  justify-content: space-between;
`;

export default SupportTicketDetails;
